export default __webpack_public_path__ + "static/media/740.2b997c62.png";